import { useMutation } from "@tanstack/react-query";
import { apiRequestSignUp, apiSendMail, apiVerifyMail } from "./service";

export const useSignUp = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiRequestSignUp(params),
  });
};

export const usePostEmailSend = () => {
  return useMutation({
    mutationFn: () => apiSendMail(),
  });
};

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiVerifyMail(params),
  });
};
